import $ from 'jquery';
import Vue from 'vue';
import moment from 'moment';
import 'daterangepicker';
import 'jquery-typeahead';

moment.locale('th');
$(document).ready(function () {
  //console.log('xxxxx search form a:','start...');
 //console.log('test nack');
 
  $('.wow-search-form-a').each(function () {
    const component_id = $(this).data('component-id');
    if ($('#vue-wow-search-form-a_' + component_id).length && typeof window['WowSearchFormNewA' + component_id] == "undefined") {
      const inlineDataStartDate = $('#vue-wow-search-form-a_' + component_id + ' [name="daterange"]').data('startdate') || null;
      const inlineDataEndDate = $('#vue-wow-search-form-a_' + component_id + ' [name="daterange"]').data('enddate') || null;
      const inlineDataDestination = $('#vue-wow-search-form-a_' + component_id + ' [name="q"]').val() || null;
      const inlineDataCode = $('#vue-wow-search-form-a_' + component_id + ' [name="code"]').val() || null;
      const inlineDataMonth = $('#vue-wow-search-form-a_' + component_id + ' [name="_month"]').val() || null;
      //console.log(inlineDataStartDate);
      //console.log(inlineDataEndDate);
      window['WowSearchFormNewA' + component_id] = new Vue({
        el: '#vue-wow-search-form-a_' + component_id,
        data: {
          formData: {
            startdate: inlineDataStartDate ? moment(inlineDataStartDate).format('YYYY-MM-DD') : null,
            enddate: inlineDataEndDate ? moment(inlineDataEndDate).format('YYYY-MM-DD') : null,
            q: inlineDataDestination || null,
            code: inlineDataCode || null,
            month: inlineDataMonth || '',
          },
          valueDateFormat: 'YYYY-MM-DD',
          displayDateFormat: 'DD MMM YYYY',
          filter_price: '',
        },
        watch: {
          filter_price: function (val) {
            [this.formData.pricemin, this.formData.pricemax] = val.split('-');
          },
          'formData.month': function (month) {
            if (month) {
              this.clearDateRange();
            }
          },
          'formData.startdate': function (date) {
            if (date) {
              this.clearMonth();
            }
          }
        },
        created: function () {
          this.loadSearchData();
          const params = this.getParams();
          if (params.filter_stayday) this.formData.filter_stayday = params.filter_stayday;
          if (params.filter_months) this.formData.filter_months = params.filter_months;
          if (params.pricemin && params.pricemax) {
            this.filter_price = [params.pricemin, params.pricemax].join('-');
          }
        },
        methods: {
          loadSearchData: function () {
            const dfd = $.Deferred();
            this.dfdSearchData = dfd.promise();
            if (typeof (Storage) !== "undefined" && localStorage.txSearchData) {
              const data = JSON.parse(localStorage.txSearchData);
              dfd.resolve(data);
            } else {
              $.get(window.AJAX_URL, {
                dataType: 'json',
                action: 'getsearchdata',
                _wpnonce: AJAX_NONCE,
              }, function (data) {
                const searchDataString = JSON.stringify(data);
                if (window.isLocalStorageNameSupported() !== false) {
                  localStorage.setItem('txSearchData', searchDataString);
                }
                dfd.resolve(data);
              });
            }
          },
          getParams: function (url = window.location.href) {
            var params = {};
            var parser = document.createElement('a');
            parser.href = url;
            var query = parser.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
              var pair = vars[i].split('=');
              params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
          },
          initDestinationTypeahead: function () {
	    //console.log('Start Bind typeahead');
            this.dfdSearchData.done((searchData) => {
	    //console.log('searchData:', searchData);
              $.typeahead({
                input: '.js-destination-typeahead_' + component_id,
                display: 'name',
                minLength: 1,
                hint: true,
                highlight: false,
                debug: false,
                maxItem: 100,
                offset: false,
                cache: true,
                cancelButton: false,
                source: {
                  data: searchData,
                },
                callback: {
                  onLeave: () => {
                    this.formData.q = $('.js-destination-typeahead_' + component_id).val() || null;
                  },
                },
              });
              $('.js-destination-typeahead_' + component_id).on('change', (e) => {
                this.formData.q = $(e.target).val() || null;
              });
            });
          },
          initDateRangePicker: function () {
            $('.js-daterangepicker', this.$el).daterangepicker({
              autoApply: true,
              autoUpdateInput: false,
              startDate: inlineDataStartDate ? moment(inlineDataStartDate) : false,
              endDate: inlineDataEndDate ? moment(inlineDataEndDate) : false,
              firstDay: 1,
              opens: 'center',
            })
              .on('show.daterangepicker', (e, dp) => {
                if ($(dp.container[0]).parents('.mm-page').length) $(dp.container[0]).appendTo('body');
              })
              .on('apply.daterangepicker', this.setDatePickerValue)
              .on('hide.daterangepicker', (e, picker) => {
                if (!$(e.target).val() && (this.formData.startdate || this.formData.enddate)) {
                  this.formData.startdate = null;
                  this.formData.enddate = null;
                  picker.startDate = moment();
                  picker.endDate = moment();
                } else if ($(e.target).val()) {
                  this.setDatePickerValue();
                }
              });
            if (this.formData.startdate && this.formData.enddate) {
              this.setDatePickerValue();
            }
          },
          setDatePickerValue: function () {
            const $inputDateRange = $('.js-daterangepicker', this.$el);
            const picker = $inputDateRange.data('daterangepicker');
            $inputDateRange.val(picker.startDate.format(this.displayDateFormat) + ' - ' + picker.endDate.format(this.displayDateFormat));
            this.formData.startdate = picker.startDate.format(this.valueDateFormat);
            this.formData.enddate = picker.endDate.format(this.valueDateFormat);
          },
          onSubmit: function () {
            const data = this.formData;
            for (const propName in data) {
              if (data[propName] === null || data[propName] === '' || data[propName] === undefined) {
                delete data[propName];
              }
            }
            location.href = ($('base').attr('href') || '') + '/search-tour/?' + $.param(data);
          },
          clearDateRange: function () {
            const $inputDateRange = $('.js-daterangepicker', this.$el);
            const picker = $inputDateRange.data('daterangepicker');
            $inputDateRange.val('');
            $inputDateRange.trigger('hide.daterangepicker', picker);
          },
          clearMonth: function () {
            this.formData.month = '';
          }
        },
        mounted: function mounted() {
          this.initDestinationTypeahead();
          this.initDateRangePicker();
          
          const vueFormData = this;
    
              jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="daterangepicker_end"]').on('change', function() {
                let startDate = jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="daterangepicker_start"]').val();
                let endDate = jquery__WEBPACK_IMPORTED_MODULE_0___default()('input[name="daterangepicker_end"]').val();
    
                if ( startDate && endDate ) {
                    let startDateArray = startDate.split('/');
                    let endDateArray = endDate.split('/');
    
                    let startDateFormatted = startDateArray[2] + '-' +  startDateArray[1] + '-' + startDateArray[0];
                    let endDateFormatted = endDateArray[2] + '-' +  endDateArray[1] + '-' + endDateArray[0];
    
                    vueFormData.formData = {...vueFormData.formData, startdate:startDateFormatted, enddate:endDateFormatted};
    
                    let startDateMoment = moment__WEBPACK_IMPORTED_MODULE_2___default()(startDateFormatted);
                    let endDateMoment = moment__WEBPACK_IMPORTED_MODULE_2___default()(endDateFormatted);
    
                    jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-daterangepicker').val(startDateMoment.format('DD MMM YYYY') + ' - ' + endDateMoment.format('DD MMM YYYY'));
    
                }
    
              });
        },
      });

      $('#js-from-click-show_' + component_id).click(function () {
        if (window.matchMedia('(min-width: 900px)').matches) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-from-show-hide').removeClass('js-from-hide');
        }
          });
          $('#js-from-click-hide_' + component_id).click(function () {
            $('.js-from-show-hide').addClass('js-from-hide');
          });
    
        }
      });
    })
    